import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { LinkType } from '../../../../../containers/Editor/constants';
import RadioBox from '../../../../Form/RadioBox';

interface LinkTypeToggleProps {
	type: LinkType;
	onChange: (type: string) => void;
}

const LinkTypeToggle = ({ type, onChange }: LinkTypeToggleProps) => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		onChange(value);
	};

	return (
		<>
			<RadioBox
				name="linkType"
				label={<Translate value="messages.url" />}
				value={LinkType.url}
				isChecked={type === LinkType.url}
				onChange={handleChange}
			/>
			<RadioBox
				name="linkType"
				label={<Translate value="messages.goto_page" />}
				value={LinkType.gotoPage}
				isChecked={type === LinkType.gotoPage}
				onChange={handleChange}
			/>
		</>
	);
};

export default LinkTypeToggle;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/LinkPanel/LinkTypeToggle/index.tsx